<template>
  <div class="foot">
    <a
      href="https://work.weixin.qq.com/kfid/kfcd2abf8edab2d31cd"
      class="left-button pfm"
      >咨询客服</a
    >
    <a
      href="http://www.89mc.com/banzuhui/download.html"
      class="right-button pfm"
      >下载班组云APP</a
    >
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {};
  },
  watch: {},
  computed: {},
  methods: {},
  created() {},
  mounted() {},
};
</script>
<style lang="less" scoped>
.foot {
  width: 100%;
  height: calc(50px + constant(safe-area-inset-bottom));
  height: calc(50px + env(safe-area-inset-bottom));
  display: flex;
  justify-content: space-around;
  align-items: center;
  position: fixed;
  left: 0;
  bottom: 0;
  padding-bottom: constant(safe-area-inset-bottom); // 兼容 IOS<11.2/
  padding-bottom: env(safe-area-inset-bottom); // 兼容 IOS>11.2/
  box-shadow: 6px 1px 8px 2px rgba(0, 0, 0, 0.11);
  // background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #ffffff 100%);
  background: #fff;
  z-index: 1;
  a {
    width: 166px;
    height: 36px;
    border-radius: 8px;
    display: inline-block;
    font-size: 14px;
    text-align: center;
    line-height: 36px;
  }
  .left-button {
    background: #fef2e9;
    color: #fa964b;
  }
  .right-button {
    background: #fa964b;
    color: #ffffff;
  }
}
</style>
